import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';

import { capitalize } from 'lodash';

type UseRegionOutput = {
  regions: string[];
  regionOptions: Array<{ value: string; label: string }>;
};

// https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/using-regions-availability-zones.html
const AWSRegionFriendlyNameLookup: Record<string, string> = {
  'us-east-2': 'US East (Ohio)',
  'us-east-1': 'US East (N. Virginia)',
  'us-west-1': 'US West (N. California)',
  'us-west-2': 'US West (Oregon)',
  'af-south-1': 'Africa (Cape Town)',
  'ap-east-1': 'Asia Pacific (Hong Kong)',
  'ap-southeast-3': 'Asia Pacific (Jakarta)',
  'ap-south-1': 'Asia Pacific (Mumbai)',
  'ap-northeast-3': 'Asia Pacific (Osaka)',
  'ap-northeast-2': 'Asia Pacific (Seoul)',
  'ap-southeast-1': 'Asia Pacific (Singapore)',
  'ap-southeast-2': 'Asia Pacific (Sydney)',
  'ap-northeast-1': 'Asia Pacific (Tokyo)',
  'ca-central-1': 'Canada (Central)',
  'eu-central-1': 'Europe (Frankfurt)',
  'eu-central-2': 'Europe (Zurich)',
  'eu-west-1': 'Europe (Ireland)',
  'eu-west-2': 'Europe (London)',
  'eu-south-1': 'Europe (Milan)',
  'eu-west-3': 'Europe (Paris)',
  'eu-north-1': 'Europe (Stockholm)',
  'me-south-1': 'Middle East (Bahrain)',
  'sa-east-1': 'South America (São Paulo)',
  'us-gov-east-1': 'AWS GovCloud (US-East)',
  'us-gov-west-1': 'AWS GovCloud (US-West)',
};

export const useRegions = (): UseRegionOutput => {
  const { cloudProvisioningRegionsBetaAccess } = useFlagsProxy();
  const regionOptions =
    cloudProvisioningRegionsBetaAccess.map((value: string) => ({
      value,
      label: toRegionName(value),
    }));

  return {
    regions: cloudProvisioningRegionsBetaAccess,
    regionOptions,
  };
};

export const toRegionName = (region: string): string => {
  if (!region) {
    return '-';
  }

  if (region in AWSRegionFriendlyNameLookup) {
    return AWSRegionFriendlyNameLookup[region];
  }

  const [country, coast, zone] = region.split('-');

  return `${country.toUpperCase()}-${capitalize(coast)}-${zone}`;
};
